import VueMultiselect from 'vue-multiselect';

// TODO: There are some selects with an "all" option with a checkbox - this can be achived by using this feature in vue-multiselect - https://vue-multiselect.js.org/#sub-option-groups
export default {
    name: 'QSelect',
    components: {
        VueMultiselect
    },
    props: {
        id: {
            type: String,
            default: ''
        },
        // Options in the select
        options: {
            type: [Array, Object],
            required: true
        },
        // v-model
        selected: {
            type: [String, Number, Array, Object],
            default: ''
        },
        // trackby is for selected value
        // Used to compare objects. Only use if options are objects.
        trackBy: {
            type: String,
            default: 'id'
        },
        // Label from option Object, that will be visible in the dropdown.
        label: {
            type: String,
            default: 'label'
        },
        // Equivalent to the placeholder attribute on a <select> input.
        placeholder: {
            type: String,
            default: ''
        },
        // In our case, the multiselect acts like the tagging component - https://vue-multiselect.js.org/#sub-tagging
        multiple: {
            type: Boolean,
            default: false
        },
        taggable: {
            type: Boolean,
            default: false
        },
        // Add / removes search input.
        searchable: {
            type: Boolean,
            default: true
        },
        disabled: {
            type: Boolean,
            default: false
        },
        // Grouping - like optgroups
        // https://vue-multiselect.js.org/#sub-option-groups
        groupValues: {
            type: String,
            default: ''
        },
        groupLabel: {
            type: String,
            default: ''
        },
        // Props for vue-multiselect - deselectGroupLabel, selectGroupLabel, selectLabel
        groupSelectable: {
            type: Boolean,
            default: true
        },
        // A couple of dropdowns have checkboxes
        hasCheckboxes: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'md'
        },
        // TODO: Document what this is for when I realize what it is used for
        info: {
            type: String,
            default: ''
        },
        // NEW - Allows to remove all selected values. Otherwise one must be left selected.
        allowEmpty: {
            type: Boolean,
            default: true
        },
        // We could make this a slot like optionPrefix
        noResultMessage: {
            type: String,
            default: 'No results found'
        },
        showExpanded: {
            type: Boolean,
            default: false,
        },
        // Helpful text for user to know how to add a new option
        tagPlaceholder: {
            type: String,
            default: 'Press enter to create a tag'
        },
        // Expands the field to see all selected options
        expand: {
            type: Boolean,
            default: false
        },
        // Shows the selected count
        showSelectedCount: {
            type: Boolean,
            default: false
        },
        // Send email report and schedule report have email dropdowns with name & email. In those use cases, the selected value needs to be truncated.
        truncateTag: {
            type: Boolean,
            default: false
        },
        // Ability to pass in a function if we need validation for tags (example: email needs to check if it's a valid email before adding it to the list of options)
        validationMethod: {
            type: Function,
            default: () => {
                return true;
            }
        },
        condensed: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            currentSelect: null,
            search: ''
        };
    },
    computed: {
        hasAction() {
            return !!this.$slots.action;
        }
    },
    methods: {
        onUpdateValue(event) {
            this.$emit('update:modelValue', event);
        },
        searchChange(value) {
            this.search = value;
        },
        addTag(newTag) {
            const tag = {
                label: newTag,
                name: newTag,
                added: true // maybe change this to class - I am going to use this for external emails
            };

            if (!this.validationMethod(tag)) {
                this.$nextTick(() => {
                    this.currentSelect.search = newTag;
                });
            }
        },
        // Removing a selected option from the v-model
        removeElement(index) {
            // Remove the element from the selection
            this.selected.splice(index, 1);
        }
    },
    mounted() {
        // Since we can't use refs, we need to get the element for reference.
        this.currentSelect = this.$refs.currentSelect;
    }
};
